import QuestionList from '../questionlist/QuestionList.vue'
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue'

export default {
    components: {
        QuestionList,
        ServiceInformation
    },
    name: 'lessonstudy',
    data() {
        return {
            tableData: [],
            //获取试题的id
            testID: '',
            //判断时长字段是否存在
            isRate: true,
            //学习按钮的字
            studyText: '',
            //我的订单的商品id
            orderGoodsId: '',
            //总课时
            sumClass: 0,
            //课程隐藏
            // huodong:false,
            // ziyuan:false,
            //已完成课时
            continueClass: {},
            finishedClass: 0,
            //项目详情
            classDetails: {},
            //产品详情
            projectDetails: {},
            resources: [{
                name: '',
                items: [{
                    name: '',
                    resources: []
                }]
            }],
            //项目
            assignment: [],
            //辅导员
            instructor: {},
            //班级介绍
            introduction: {},
            // tabresources: {},
            class_id: '',
            id: '',
            //班级文件
            classfile: [],
            //班级公告
            bulletin: [],
            //进度条成功参数
            active: 1,
            visible: false,
            // 项目大纲
            outline: [],
            // 提示框触发延迟时间
            openDelay: 500,
            //正在进行时的任务的排序
            task_index: '',
            //正在进行时的活动排序
            activite_sort_index: '',
            //重新整理的任务数组
            outlineXin: '',
            //剩余时间
            remaining: '',
            //项目进度
            progress: 0,
            //icon
            ActiveIconStatus: ['-icon-gray.png', '-icon-blue.png', '-icon-green.png'],
            //green
            img: 'https://education-test.bayou-tech.cn/img/class-icon-green.png',
            //分数
            grade: '',
            user_id: '',
            score: '', // 总分
            dialogVisible: false, // 是否显示评分详情
            // 剩余时间
            newRemaining: 0,
            // 项目结束后是否可以继续观看视频电子书，1可以
            isWatch: 0,
            // 评分规则
            proportion: '',
            ieClass: false,
            // 当前进度
            currentProgress: '',
            // 项目结束时,就不允许观看视频和电子书阅读
            continueWatch: true,
            showButton: true
        }
    },
    methods: {

        // 显示评分详情
        showVisible() {
            this.dialogVisible = true
        },

        //跳转首页
        goIndex: function() {
            this.$router.push({
                path: '/'
            })
        },

        //跳转到视频观看
        toLearnVideo(index1, index2) {
            let obj = this.outline[index1].task_activities[index2]

            // 跳转到课程作业或主题讨论是否可编辑
            let edit = true
            // 辅导员评分
            let grade = ''
            // 辅导员评论
            let instructorComment = ''

            console.log('this.continueWatch', this.continueWatch)
            console.log('obj.resources[0].items[0].type ', obj.resources[0].items[0].type)

            // 项目结束,不允许继续观看视频和电子书阅读
            if (!this.continueWatch) {
                if (obj.resources[0].items[0].type == 1 || obj.resources[0].items[0].type == 4) {
                    this.$alert('该项目培训已结束', '提示', {
                        confirmButtonText: '确定'
                    })
                    return
                }
            }

            // 项目时间未结束

            // 当前是课程作业
            if (obj.name == 'class' && obj.resources[0].items[0].type == 7) {
                console.log(obj.resources[0].items[0])
                // 有成绩不可以编辑，没有成绩可以编辑
                if (obj.resources[0].items[0].grade && obj.resources[0].items[0].progress) {
                    edit = false
                    grade = obj.resources[0].items[0].grade
                    instructorComment = obj.resources[0].items[0].instructorComment
                }
            }

            // 当前是主题讨论，学员已经完成学习
            // if (obj.name == 'discuss' && obj.activeState == 2) {
            //   edit = false
            // grade = obj.resources[0].items[0].grade
            // instructorComment = obj.resources[0].items[0].instructorComment
            // }

            // // 当前点击的是主题讨论
            // if (obj.name == 'discuss') {
            // console.log('我是主题讨论')
            //     // 如果主题讨论已经有分数，就不让进去
            //     if (obj.resources[0].items[0].grade) {
            //         this.$alert('辅导员已对该主题讨论评分，不能进行修改', '提示', {
            //             confirmButtonText: '确定'
            //         })
            //         return
            //     }

            // } else if (obj.name == 'exam') { // 当前点击的是培训心得
            // console.log('我是培训心得')
            //     // 如果主题讨论已经有分数，就不让进去
            //     if (obj.resources[0].items[0].grade) {
            //         this.$alert('辅导员已对该培训心得评分，不能进行修改', '提示', {
            //             confirmButtonText: '确定'
            //         })
            //         return
            //     }
            // } else { // 当前的是课程（包含视频、电子书阅读或课后习题，但只有课后习题是有分数的）
            //     if (obj.resources[0].items[0].grade) {
            //         this.$alert('辅导员已对该课后习题评分，不能进行修改', '提示', {
            //             confirmButtonText: '确定'
            //         })
            //         return
            //     }
            // }

            // 如果进度为100且已经有分数了，就不让观看视频了
            // if (this.progress == 100 && this.score != null) {
            //     this.$alert('恭喜，您已完成该项目的学习', '提示', {
            //         confirmButtonText: '确定'
            //     })
            //     return
            // }

            let data = {
                goodsId: this.id,
                product_id: this.id,
                project_id: this.projectDetails.id,
                purchased_id: this.classDetails.purchased_id,
                taskState_index: index1,
                activeState_index: index2,
                task_id: this.outline[index1].task_id,
                edit: edit,
                instructorComment: instructorComment,
                grade: grade,
                currentProgress: this.currentProgress
            }
            data = this.crypto_js(JSON.stringify(data))

            // let routeUrl = this.$router.resolve({
            //     name: 'studyHomePage03',
            //     query: {
            //         data: data,
            //         product_id: this.id
            //     },
            // })

            // 需要新窗口打开
            let routeUrl = this.$router.resolve({
                // name: 'studyhomepage',
                name: 'studyHomePage03',
                query: {
                    data: data,
                    product_id: this.id
                },
            })

            window.open(routeUrl.href, '_blank')
            // this.$router.push({
            //     // name: 'studyhomepage',
            //     name: 'studyHomePage03',
            //     query: {
            //         data: data,
            //         product_id: this.id
            //     },
            // })

        },

        //跳转到项目式详情
        todetailsPage(id) {
            this.$router.push({
                path: '/detailsPage',
                query: {
                    id: id
                }
            })
        },

        //跳转到云课程详情
        toclassdetails(id) {
            this.$router.push({
                path: '/classdetails',
                query: {
                    id: id
                }
            })
        },

        //跳转到云课程学习页
        toclassstudy(id) {
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: id
                }
            })
        },

        //获取产品信息
        getresources() {
            return (this.$post('products/get_pay', {
                    token: this.$store.state.id,
                    id: this.id
                })
                .then(res => {
                    // console.log('获取产品信息', res.data.result)
                    this.classDetails = res.data.result

                    document.title = this.classDetails.name

                    this.$post('projects/search', {
                        token: this.$store.state.id,
                        id: res.data.result.project_id
                    }).then(res => {
                        // console.log('获取项目信息', res.data.result)
                        this.projectDetails = res.data.result
                        this.intervalTime(this.changeDate(), this.projectDetails
                            .end_study_time) //计算剩余时间
                        this.getClassinformation() //获取班级信息
                        this.getjindu()
                    })
                })
            );
        },

        //获取班级信息
        getClassinformation() {
            this.$post('class_users/get_class_by_purchased_id', {
                    token: this.$store.state.id,
                    offset: 0,
                    length: 9999,
                    purchased_id: this.classDetails.purchased_id
                })
                .then(res => {
                    // console.log('班级信息'+res.data.status);
                    // console.log('班级信息返回'+res.data.result);
                    // console.log('miss',this.$isAbnormal(this.introduction))
                    this.getGrade()
                    if (!this.$isAbnormal(res.data.result)) {
                        // alert(111);
                        this.introduction = res.data.result
                        // console.log('班级信息', res.data.result)
                        this.getinstructor() //获取辅导员
                        this.getclassbulletin() //获取班级公告
                        this.getclass_file() //查询班级文件
                    }

                })
        },

        //获取辅导员
        getinstructor() {
            // console.log('辅导员',this.introduction.instructor_id);
            if (this.$isAbnormal(this.introduction.instructor_id)) {
                this.instructor = [];
                return false
            }
            this.$post('instructor/get', {
                    token: this.$store.state.id,
                    id: this.introduction.instructor_id
                })
                .then(res => {

                    // console.log('辅导员信息',res.data.result)
                    this.instructor = res.data.result
                })
        },

        //获取班级公告
        getclassbulletin() {
            // 若还没有班级，不存在则不请求数据
            if (this.$isAbnormal(this.introduction.id)) {
                this.bulletin = [{
                    bulletin: '还没有分配班级，请等待班级分配'
                }];
                return false
            }
            this.$post('class_bulletin/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 100,
                class_id: this.introduction.id
            }).then(res => {
                // console.log('班级公告',res.data.result.data)
                this.bulletin = res.data.result.data
            })

        },

        //查询班级文件
        getclass_file() {
            //若还没有班级，则不请求数据
            if (this.$isAbnormal(this.introduction.id)) {
                this.classfile = [];
                return false
            }
            this.$post('class_file/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 100,
                class_id: this.introduction.id
            }).then(res => {
                // console.log('班级文件', res.data.result.data)
                this.classfile = res.data.result.data
            })
        },

        //查询项目大纲
        getoutline() {
            this.$post('project_tasks/search_group_by_task', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                project_id: this.projectDetails.id
            }).then(res => {
                this.outline = res.data.result.data.map((res) => {
                    for (let i = 0; i < res.task_activities.length; i++) {
                        res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
                    }
                    return res
                })
                // 处理项目大纲
                this.handleOutline()

                // this.outline = res.data.result.data.map((res) => {
                //   console.log('res', res)
                //   for (let i = 0; i < res.task_activities.length; i++) {
                //     res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
                //  console.log(res.task_activities[i].resources)
                //   }
                //   return res
                // })
                // this.outline[0].taskState = 1
                // this.outline[0].task_activities[0].activeState = 1
                // console.log('查询项目大纲的this.shujuchul()先执行')
                // this.shujuchul()
                //this.zhenglixiangmushuzhu()
                // console.log('项目大纲', this.outline)
            })
        },

        /**
         * 处理项目大纲
         */
        handleOutline() {
            // console.log('处理项目大纲')
            // console.log('旧的outline', this.outline)
            this.outline.map(task => {
                task.taskState = 1

                task.task_activities.map(activity => {
                    activity.activeState = 1

                    activity.resources.map(resource => {
                        resource.state = 1

                        resource.items.map(item => {
                            item.progress = 0
                            item.state = 1
                        })
                    })
                })
            })
            // console.log('新的outline', JSON.stringify(this.outline))

            // 获取评分规则
            this.getCodePoints()
        },

        // 判断课程是否购买
        judgeBuy() {

            let BZ //是否购买变量
            let is_project
            // console.log('ispay执行了')
            this.$post('users/isPay', { //返回true则没有购买，返回false就说明已经购买
                token: this.$store.state.id,
                product_id: this.id,
            }).then(res => {
                // console.log('是否购买', res.data.result)
                BZ = res.data.result
                this.$post('products/get', { //返回is_project =1 是项目式  0 是云课程
                    token: this.$store.state.id,
                    id: this.id,
                }).then(res => {
                    // console.log('判断课程类型', res)
                    // console.log('判断课程类型', res.data.result.is_project)
                    is_project = res.data.result.is_project
                    if (BZ == true) { //没有购买
                        if (is_project == 1) {
                            this.todetailsPage(this.id) //跳转至项目式详情页
                        } else {
                            this.toclassdetails(this.id) //跳转至云课程详情页
                        }
                    } else {
                        if (is_project == 1) {
                            this.getresources() //获取信息数据
                        } else {
                            this.toclassstudy(id)(this.id) //跳转至云课程学习页
                        }

                    }
                })
            })
        },

        // 查询进度并查询项目大纲
        getjindu() {
            this.$post('purchased/get', {
                token: this.$store.state.id,
                id: this.classDetails.purchased_id
            }).then(res => {

                let data = res.data.result

                // 获取当前进度
                this.currentProgress = data.progress

                this.progress = +(data.progress * 100).toFixed(2) //保存总进度
                this.score = res.data.result.score // 获取评分
                if (data.rate == null || data.rate == '') {
                    // console.log('获取进度大纲')
                    this.getoutline() // 无进度获取项目大纲
                    // console.log('无进度大纲')

                } else {
                    // console.log('有进度')
                    this.outline = JSON.parse(data.rate) //有进度获取进度数据
                    // console.log('获取rate的先执行')
                    // console.log("现在的this.outline是 ", this.outline);
                    // this.shujuchul()

                    // 获取评分规则
                    // this.getCodePoints()

                }

            })
        },

        //数据处理
        shujuchul() {
            // console.log('处理之前的大纲：', JSON.stringify(this.outline))
            // 查找当前进行的任务
            for (let i = 0; i < this.outline.length; i++) {
                if (this.outline[i].taskState == 1) {
                    this.task_index = this.outline[i].sort
                    break
                }
            }
            // 查找和当前任务一样排序的任务
            for (let i = 0; i < this.outline.length; i++) {
                if (this.outline[i].sort == this.task_index && this.outline[i].taskState != 2) {
                    this.outline[i].taskState = 1
                    let tt = true
                    for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                        if (this.outline[i].task_activities[j].activeState == 1) {
                            tt = false
                            this.activite_sort_index = this.outline[i].task_activities[j].activite_sort //当前活动的排序
                            for (; j < this.outline[i].task_activities.length; j++) {
                                // console.log('进来了')
                                if (this.outline[i].task_activities[j].activite_sort == this.activite_sort_index &&
                                    this.outline[i].task_activities[
                                        j].activeState != 2) {
                                    this.outline[i].task_activities[j].activeState = 1
                                }
                            }
                        }
                    }
                    if (tt) { //没有找到
                        this.outline[i].task_activities[0].activeState = 1
                        this.activite_sort_index = this.outline[i].task_activities[0].activite_sort //当前活动的排序
                        for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                            if (this.outline[i].task_activities[j].activite_sort == this.activite_sort_index && this
                                .outline[
                                    i].task_activities[
                                    j].activeState != 2) {
                                this.outline[i].task_activities[j].activeState = 1
                            }
                        }
                    }
                }
            }
            // console.log('已处理大纲数据：', this.outline)
            // 保存进度
            let json1 = JSON.stringify(this.outline)
            // console.log('处理之后的大纲：', json1)
            // console.log('我提交了')
            this.$post('purchased/sumbitRate', {
                token: this.$store.state.id,
                id: this.classDetails.purchased_id,
                rate: json1
            })
            // console.log('我提交好了')

            // console.log('进度：' ,this.outline)
        },

        //继续学习
        continueLearning() {
            UIkit.switcher(study).show(1);
            this.showButton = false;
        },

        //去除重复元素.
        removeRepeatArray(arr) {
            return arr.filter(function(item, index, self) {
                return self.indexOf(item) === index;
            });
        },

        //获取数据.
        getIcon() {
            this.$post('icon/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                type: '',
                state: ''
            })
        },

        //时区日期格式转换(TZ)
        changeDate() {
            let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/,
                '')
            // console.log('当前时间', date)
            return date;
        },

        //时区日期格式转换(TZ)
        intervalTime(startTime, endTime) {
            startTime = startTime.substring(0, 10)
            var date1 = new Date(startTime); //开始时间
            var date2 = new Date(endTime); //结束时间
            var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
            //计算出相差天数
            var days = Math.floor(date3 / (24 * 3600 * 1000));
            //计算出小时数
            var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / (3600 * 1000));
            //计算相差分钟数
            var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2 / (60 * 1000));
            //计算相差秒数
            var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3 / 1000);
            //alert(" 用时： " + days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒")
            this.remaining = days

            return days
        },

        /**
         * @author  :  zgg
         * @created :  2019/07/1
         * @version :  v1.0
         * @desc    :  url传参加密
         */
        crypto_js(pas) {
            var CryptoJS = require("crypto-js");
            var ciphertext = CryptoJS.AES.encrypt(pas + '', '18888888888').toString();
            return ciphertext
        },

        // 学习进度100时点击继续学习调用该方法
        showTips() {
            this.$alert('您已经完成该课程的学习', '提示', {
                confirmButtonText: '确定'
            });
        },

        //获取分数
        getGrade() {
            // console.log(this.introduction.id)
            this.$post('users/profile', {
                token: this.$store.state.id,
            }).then(res => {
                // console.log(res.data.result)
                this.user_id = res.data.result.id
                this.$post('purchased/get', {
                    token: this.$store.state.id,
                    id: this.classDetails.purchased_id
                }).then(res => {
                    // console.log(res)
                    this.grade = res.data.result.score

                    // 如果有分数，则计算显示课程分数详情
                    if (!this.$isAbnormal(this.grade)) {
                        // 计算显示分数
                        this.calculateScore()
                    }

                })
                this.getAnswer()
            })
        },

        //获取答案
        getAnswer() {
            for (let i in this.outline) {
                for (let j in this.outline[i].task_activities) {
                    for (let x in this.outline[i].task_activities[j].resources) {
                        for (let y in this.outline[i].task_activities[j].resources[x].items) {
                            let resourcesID = this.outline[i].task_activities[j].resources[x].items[y].resources[0]
                            switch (this.outline[i].task_activities[j].resources[x].items[y].type) {
                                case 7: {
                                    this.getPrivate(resourcesID, i, j, x, y)
                                    break;
                                }
                                case 6: {
                                    this.getDiscuss(resourcesID, i, j, x, y)
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                    }
                }
            }
        },

        getDiscuss(resourcesID, i, j, x, y) {
            this.$post('resources/get_comment', {
                id: resourcesID,
                user_id: this.user_id,
                token: this.$store.state.id,
                offset: 0,
                length: 999
            }).then(res => {
                // console.log(res.data.result.data)
                this.outline[i].task_activities[j].resources[x].items[y].answer = res.data.result.data[0]
            })
        },

        getPrivate(resourcesID, i, j, x, y) {
            this.$post('private/get', {
                token: this.$store.state.id,
                resource_id: resourcesID,
                purchased_id: this.classDetails.purchased_id
            }).then(res => {
                // console.log(res.data.result,5555)

                this.outline[i].task_activities[j].resources[x].items[y].answer = res.data.result
            })
        },

        // 获取评分规则
        getCodePoints() {
            // console.log('获取评分规则')
            this.$post('proportion/get', {
                product_id: this.id
            }).then(res => {
                this.proportion = JSON.parse(res.data.result.resources)
                this.circulation()
            })
        },

        // 插入评分规则
        circulation() {
            // console.log('插入评分规则')
            debugger
            for (let i = 0; i < this.outline.length; i++) {
                this.outline[i].percentage = this.proportion[i].percentage
                for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                    this.outline[i].task_activities[j].percentage = this.proportion[i].task_activities[j].percentage
                    for (let y = 0; y < this.outline[i].task_activities[j].resources.length; y++) {
                        this.outline[i].task_activities[j].resources[y].percentage = this.proportion[i].task_activities[
                            j].resources[y].percentage
                        // if (this.proportion[i].task_activities[j].resources[y].rule === 1) {
                        //     this.regulation.push({ i: i, j: j, y: y })
                        // }
                        for (let z = 0; z < this.outline[i].task_activities[j].resources[y].items.length; z++) {
                            try {
                                this.outline[i].task_activities[j].resources[y].items[z].percentage = this.proportion[i]
                                    .task_activities[j].resources[y].items[z].percentage
                                this.outline[i].task_activities[j].resources[y].items[z].rule = this.proportion[i]
                                    .task_activities[
                                        j].resources[y].items[z].rule
                            } catch {
                                console.log(`问题出现在 ${i} , ${j} ,  ${y} , ${z}`)
                            }
                        }
                    }
                }
            }
            // console.log('插入评分规则')
            // 发送请求保存项目大纲
            this.$post('purchased/sumbitRate', {
                token: this.$store.state.id,
                id: this.classDetails.purchased_id,
                rate: JSON.stringify(this.outline)
            })
        },

        // 计算分数
        calculateScore() {
            let list = []

            let points1 = 0
            for (let i = 0; i < this.outline.length; i++) {
                let points2 = 0
                let outline = this.outline[i]
                // console.log('outline', outline)

                let obj = {
                    videolearningProcess:0,
                    pdflearningProcess:0,
                    coursework:0,
                    topicDiscuss:0,
                    trainingLog:0,
                }
                // 学习过程分数（视频+电子书阅读）
                let videolearningProcess = 0;
                let pdflearningProcess = 0;
                // 课程作业分数
                let coursework = 0;
                // 主题讨论分数
                let topicDiscuss = 0;
                // 研修日志分数
                let trainingLog = 0;
                obj.name = this.outline[i].task_name
                for (let j = 0; j < this.outline[i].task_activities.length; j++) {

                    let points3 = 0
                    let task_activitie = this.outline[i].task_activities[j]

                    // 每个活动的评分占比
                    let percentage1 = this.outline[i].task_activities[j].percentage
                    // console.log('percentage1', percentage1)

                    for (let y = 0; y < this.outline[i].task_activities[j].resources.length; y++) {
                        let points4 = 0
                        let resource = this.outline[i].task_activities[j].resources[y]
                        for (let z = 0; z < this.outline[i].task_activities[j].resources[y].items.length; z++) {
                            let item = this.outline[i].task_activities[j].resources[y].items[z]
                            let state = item.state ? item.state : 0
                            state = parseInt(state)
                            let grade = item.grade ? item.grade : 0
                            grade = parseInt(grade)
                            let rule = item.rule
                            rule = parseInt(rule)
                            if (state === 2) {
                                if (rule === 1) {
                                    points4 += grade
                                } else {
                                    points4 += 100
                                }
                            }

                        }
                        //每小节的分数
                        points4 = points4 / resource.items.length
                        // 每个章的分数
                        points3 += points4 * resource.percentage / 100
                        
                    }
                    

                    // point3是每个活动的得分
                    // console.log('points3', points3)
                    let item1 = this.outline[i].task_activities[j].resources[0].items[0]
                    // 是视频或电子书阅读
                    if (item1.type == 1) {
                        videolearningProcess += points3
                        obj.videolearningProcess = videolearningProcess / (100 / percentage1);
                    }
                    if (item1.type == 4) {
                        pdflearningProcess += points3
                        obj.pdflearningProcess = pdflearningProcess / (100 / percentage1);
                    }
                    // 是课程作业
                    if (item1.type == 7) {
                        coursework = points3
                        obj.coursework =(coursework / (100 / percentage1));
                    }
                    // 是主题讨论
                    if (item1.type == 6) {
                        topicDiscuss = points3
                        obj.topicDiscuss = (topicDiscuss / (100 / percentage1));
                    }
                    // 是研修日志
                    if (item1.type == 8) {
                        trainingLog = points3;
                        obj.trainingLog = (trainingLog / (100 / percentage1));
                    }

                    points2 += points3 * task_activitie.percentage / 100
                }
                list.push(obj)
                points1 += points2 * outline.percentage / 100
            }
            // 计算总分
            this.getTotalScore(list)
        },

        // 计算总分
        getTotalScore(list) {
            // console.log(list)
            // list.splice(list.length - 1, 1)
            let newList = list
            // console.log(newList)
            for (let i = 0; i < newList.length; i++) {pdflearningProcess
                let videolearningProcess = newList[i].videolearningProcess;
                let pdflearningProcess = newList[i].pdflearningProcess;
                let coursework = newList[i].coursework;
                let topicDiscuss = newList[i].topicDiscuss;
                let trainingLog = newList[i].trainingLog;
                let learningProcess = videolearningProcess + pdflearningProcess;
                let score = learningProcess + coursework + topicDiscuss + trainingLog;
                newList[i].learningProcess = learningProcess;
                newList[i].score = score.toFixed(0);
            }
            // console.log(newList)
            this.tableData = newList;
            // console.log('this.tableData ', this.tableData);
        },

        // 传入一个变量，不是number类型的则返回0
        returnNum(variable) {
            if (isNaN(variable)) {
                return 0
            }
            return variable
        },

        // 计算等级
        getLevel(score) {
            if (score >= 85 && score <= 100) {
                return '优'
            } else if (score >= 70 && score <= 84) {
                return '良'
            } else if (score >= 60 && score <= 69) {
                return '及格'
            } else {
                return '不及格'
            }
        },

        /**
         * 点击标签，当是第二个标签时隐藏学习按钮
         * @param index
         */
        handleClickTab(index) {
            index === 1 ? this.showButton = false : this.showButton = true;
        }
    },


    mounted() {
        let flag = this.$route.query.flag // 传递的flag，用来跳转到学习进程
        let type = this.$route.query.type // 传递的type，用来弹出提示
        let initiativeToClick = this.$route.query.initiativeToClick // 传递的initiativeToClick，用来判断是否为学员主动退出

        if (flag) {
            this.continueLearning()
        }
        if (type === 'show' && !initiativeToClick) {
            this.$alert('请不要同时学习', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                    this.$router.push({
                        path: '/lessonstudy',
                        query: {
                            id: this.$route.query.id,
                            flag: true
                        }
                    })
                }
            })
        }
    },

    created() {

        this.id = this.$route.query.id //页面跳转传递id

        this.$post('products/get_pay', {
            token: this.$store.state.id,
            id: this.id
        }).then(res => {
            let isWatch = res.data.result.is_watch
            this.isWatch = isWatch
            // 如果isWatch为真, 那么即使项目过期也可以继续观看
            if (isWatch) {
                this.judgeBuy() // 判断课程是否购买  判断课程类型

            } else { // 如果isWatch不为真, 那只有项目的时间剩余时间大于0才可以观看视频电子书

                this.$post('projects/search', {
                    token: this.$store.state.id,
                    id: res.data.result.project_id
                }).then(res => {

                    let remaining = this.intervalTime(this.changeDate(), res.data.result
                        .end_study_time) // 计算剩余时间
                    this.newRemaining = remaining
                    // 剩余时间小于0，不允许观看视频电子书
                    if (remaining < 0) {
                        this.continueWatch = false
                    }
                    this.judgeBuy()
                })
            }
        })

        if (document.documentMode) {
            this.ieClass = true
        }


        // this.getGrade()
        // console.log('密文', this.crypto_js())
        // this.id = this.$route.query.id //页面跳转传递id
        // this.judgeBuy()   // 判断课程是否购买  判断课程类型
        // this.getClassinformation() //获取班级信息
    },
}
